

const searchIcon = document.querySelector("[data-search-link]");
const searchView = document.querySelector(".header__quick-search-bar");
const searchClear = document.querySelector("header [data-quick-search-clear]");

searchIcon.addEventListener("click", () => {
    searchClear.click();
    searchView.classList.toggle('active');
});


document.addEventListener("click", (event) => {
    if (!searchView.contains(event.target) && !searchIcon.contains(event.target)) {
       searchView.classList.remove('active');
    }
});

const cartIcon = document.querySelector("[data-cart-link]");
const cartView = document.querySelector(".quick-cart__wrapper");


cartIcon.addEventListener("click", (event) => {
    cartView.classList.toggle('active');
});

document.addEventListener("click", (event) => {
    if (!cartIcon.contains(event.target) && !cartView.contains(event.target)) {
        cartView.classList.remove('active');
    }
});
